import { useEffect, useState, useMemo } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { getRequest, postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { paths } from 'src/routes/paths';
import Iconify from 'src/components/iconify';
import { useLocation, useNavigate, useParams } from 'react-router';
import PlansCreateCards from './plans-create-form-cards';
import { useBoolean } from 'src/hooks/use-boolean';
import { PlanAddonCreateModal } from './plans-add-on-modal';

export const PlanCreateAddonPage = ({ open, onClose, reload, currentItem, closeform, }) => {
    const add = useBoolean();

    const { id } = useParams();
    const location = useLocation();
    const modules = location.state;
    const moduleslist = modules
    // console.log("modules.....>>>>>>>>>>>>>>>>>>>", modules);
    const addons = moduleslist?.filter(feature => feature.is_addon === 1);
    console.log("🚀 ~ PlanCreateAddonPage ~ addons:", addons)

    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);
    const [ newmodules, setModules ] = useState([]);

    const navigate = useNavigate();
    const NewDocumentSchema = Yup.object().shape({
    });

    const defaultValues = useMemo(
        () => ({

            code: currentItem?.code || '',
            description: currentItem?.description || '',

        }),
        [ currentItem ]
    );

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });


    useEffect(() => {
        getPlansViewDetails();
    }, []);

    const getPlansViewDetails = async () => {
        setLoading(true);

        const data = await getRequest(`${endpoints.admin_dashboard.packages_plans.plans.show_plans}/${id}`);
        if (data) {
            const filteredModules = data?.product_modules
                .map(module => ({
                    ...module,
                    feature_list: module?.feature_list?.filter(feature => feature.is_addon === 1)
                })).filter(module => module.feature_list.length > 0);
            console.log("🚀 ~ getPlansViewDetails ~ filteredModules:", filteredModules)

            setModules(filteredModules);
        }

        setLoading(false);
    };




    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('code', data.code);
        formData.append('description', data.description);
        try {
            const response = await postRequest(
                currentItem?.id
                    ? `${endpoints.admin_dashboard.teachnical_database.cost_codes.post_list}/${currentItem.id}?_method=PUT`
                    : endpoints.admin_dashboard.teachnical_database.cost_codes.post_list,
                formData,
                true
            );

            if (response.metadata?.success) {
                reset();
                onClose();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    return (<>

        <FormProvider methods={ methods } onSubmit={ onSubmit } >
            <CustomBreadcrumbs
                heading="Product / Packages Plan
"
                links={ [ { name: '', href: paths.dashboard.root } ] }
                action={
                    <>
                        <Button
                            sx={ { marginRight: "10px" } }
                            onClick={ () => navigate("/dashboard/product-packages/plans") }
                            variant="contained"
                            startIcon={ <Iconify icon="material-symbols:arrow-back-ios-rounded" /> }
                        >
                            Back
                        </Button>
                        <Button
                            sx={ { marginRight: "10px" } }
                            variant="contained"
                            onClick={ () => add.onTrue() }
                            startIcon={ <Iconify icon="material-symbols:add-2-rounded" /> }
                        >
                            Add New Module Add on
                        </Button>
                    </>
                }
                sx={ {
                    mb: { xs: 3, md: 2 },
                } }
            />
        </FormProvider>

        <Stack
            sx={ {
                padding: "20px",
                borderRadius: "5px",
                marginTop: "20px",
            } }
        >
            <Typography variant="h6">
                { "Plan  Add-ons" }
            </Typography>
        </Stack>
        { newmodules?.map((module, index) =>
        (
            <PlansCreateCards
                module_name={ "Plan Add on   Features" }
                plan_name={ module?.module_name }
                features={ module?.feature_list }
            // view={ "view" }


            />))
        }
        <PlanAddonCreateModal
            open={ add.value }
            onClose={ add.onFalse }
            features={ moduleslist }
            reload={ () => moduleslist }
        />
        {/* <PlanAddonCreateModal
            open={ add.value }
            onClose={ add.onFalse }
            features={ moduleslist }
        /> */}
    </>
    );
};